<span class="aro-title">{{'ARO.CLASSIFICATIONS' | translate}}</span>
<mat-card class="box-bottom-border">
  <div fxLayout="row" fxLayoutGap="0px" fxLayoutAlign="space-evenly">
    <div fxFlex="50%" class="box-top-bottom-padding-right-border" fxLayout="column" fxLayoutAlign="center center">
      <div>{{systemClass}}</div>
      <div class="aro-label">{{'ARO.SYSTEM_CLASSIFICATION' | translate}}</div>
    </div>
    <div fxFlex="50%" fxLayout="column" class="box-top-bottom-padding" fxLayoutAlign="center center">
      <div>{{operatorClass}}</div>
      <div class="aro-label">{{'ARO.OPERATOR_CLASSIFICATION' | translate}}</div>
    </div>
  </div>
</mat-card>
<mat-card class="box-bottom-border">
  <div fxLayout="row" fxLayoutGap="0px" fxLayoutAlign="space-evenly">
    <div fxFlex="33%" class="box-top-bottom-padding-right-border" fxLayout="column" fxLayoutAlign="center center">
      <div>{{fighter}}</div>
      <div class="aro-label">{{'ARO.FIGHTER' | translate}}</div>
    </div>
    <div fxFlex="34%" class="box-top-bottom-padding-right-border" fxLayout="column" fxLayoutAlign="center center">
      <div>{{helicopter}}</div>
      <div class="aro-label">{{'ARO.HELICOPTER' | translate}}</div>
    </div>
    <div fxFlex="33%" fxLayout="column" fxLayoutAlign="center center">
      <div>{{subsonicMissile}}</div>
      <div class="aro-label">{{'ARO.SUBSONICMISSILE' | translate}}</div>
    </div>
  </div>
</mat-card>
<mat-card class="box-bottom-border">
  <div fxLayout="row" fxLayoutGap="0px" fxLayoutAlign="space-evenly">
    <div fxFlex="33%" class="box-top-bottom-padding-right-border" fxLayout="column" fxLayoutAlign="center center">
      <div>{{supersonicMissile}}</div>
      <div class="aro-label">{{'ARO.SUPERSONICMISSILE' | translate}}</div>
    </div>
    <div fxFlex="34%" class="box-top-bottom-padding-right-border" fxLayout="column" fxLayoutAlign="center center">
      <div>{{transporter}}</div>
      <div class="aro-label">{{'ARO.TRANSPORTER' | translate}}</div>
    </div>
    <div fxFlex="33%" fxLayout="column" fxLayoutAlign="center center">
      <div>{{uav}}</div>
      <div class="aro-label">{{'ARO.UAV' | translate}}</div>
    </div>
  </div>
</mat-card>


<!-- Correlated Sensors table -->
<!-- <span class="aro-title">{{'ARO.CORRELATED_SENSORS' | translate}}</span>
<mat-card>
  <div class="track-aro-corr-tracks-table-container">
    <table mat-table [dataSource]="corrSensorsDataSource" matSort class="track-aro-corr-tracks-table" #corrSensorsTable>
      <ng-container matColumnDef="sic">
        <th mat-header-cell *matHeaderCellDef mat-sort-header style="user-select: none;">Sic</th>
        <td mat-cell *matCellDef="let correlation">{{correlation.sic}}</td>
      </ng-container>
      <ng-container matColumnDef="sac">
        <th mat-header-cell *matHeaderCellDef mat-sort-header style="user-select: none;">Sac</th>
        <td mat-cell *matCellDef="let correlation">{{correlation.sac}} </td>
      </ng-container>
      <ng-container matColumnDef="letter">
        <th mat-header-cell *matHeaderCellDef mat-sort-header style="user-select: none;">Sym</th>
        <td mat-cell *matCellDef="let correlation">{{correlation.letter}} </td>
      </ng-container>
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef style="user-select: none;">
          <mat-icon class="dialog-button-icon">touch_app</mat-icon>
        </th>
        <td mat-cell *matCellDef="let correlation">
          <button class="dialog-button" mat-icon-button tabindex="-1" (click)="onCenterClick(correlation.id)"
            title="Center">
            <mat-icon class="dialog-button-icon">room</mat-icon>
          </button>
          <button class="dialog-button" mat-icon-button tabindex="-1" (click)="onAroClick(correlation.id)"
            title="Remote Hook Object">
            <mat-icon class="dialog-button-icon">touch_app</mat-icon>
          </button>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="corrSensorsColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: corrSensorsColumns"></tr>
    </table>
  </div>
</mat-card> -->